
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import EDTooltip from '../../../../../../../../../../../../BaseComponents/Tooltip/EDTooltip';
import EDIcon from '../../../../../../../../../../../../BaseComponents/Icon/EDIcon';
import EDFormHelperText from '../../../../../../../../../../../../BaseComponents/FormHelperText/EDFormHelperText';

interface IProps {
  autoComplete: React.ReactNode;
  fullscreen?: boolean;
  warning?: string;
  typingWarning?: string;
  disableInputHelperText?: boolean;
}

const useStyles = makeStyles()((theme: Theme) => ({
  emptySpace: {
    width: 38,
  },
  warningIconFullscreen: {
    marginRight: theme.spacing(1),
  },
  topContainer: {
    flex: '2 1 0%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
  },
  helperTextContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: -4,
    marginBottom: 8,
  },
  helperTextContainerFullscreen: {
    marginBottom: theme.spacing(1),
  },
  helperTextFullscreen: {
    color: theme.palette.common.white,
  },
}));

const EkonomiskAnalysSelectionWrappedAutoComplete: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes, cx } = useStyles();
  return (
    <div className={classes.flexContainer}>
      <span className={classes.topContainer}>
        {props.autoComplete}
        {props.warning !== undefined &&
          (props.warning === '' ? (
            <span className={classes.emptySpace} />
          ) : (
            <EDTooltip title={props.warning}>
              <span>
                <EDIcon
                  marginLeft={1}
                  marginRight={props.fullscreen ? 1 : undefined}
                  color="warning"
                  iconType="warning"
                />
              </span>
            </EDTooltip>
          ))}
      </span>
      {!props.disableInputHelperText && (
        <div
          className={cx(classes.helperTextContainer, {
            [classes.helperTextContainerFullscreen]: props.fullscreen,
          })}
        >
          <EDFormHelperText
            margin="dense"
            className={cx({
              [classes.helperTextFullscreen]: props.fullscreen,
            })}
          >
            {props.typingWarning}
          </EDFormHelperText>
        </div>
      )}
    </div>
  );
};

export default EkonomiskAnalysSelectionWrappedAutoComplete;
